import React from "react";
import cn from "classnames";
import Icon from "components/Icon";

//import PropTypes from 'prop-types';

export function SelectListItem(props) {
    const {
        children,
        label,
        onClick,
        checkbox,
        checkboxIcon,
        checkboxUncheckedIcon,
        subtitle,
        icon,
        isSelected,
    } = props;
    return (
        <div
            className={cn("select-list-item", {
                "is-checkbox": checkbox,
                "is-selected": isSelected,
            })}
            onClick={onClick}
        >
            {checkbox && (
                <div className={"select-list-item-chk"}>
                    <Icon>
                        {isSelected ? checkboxIcon : checkboxUncheckedIcon}
                    </Icon>
                </div>
            )}
            {icon && <div className={"select-list-item-icon"}>{icon}</div>}
            <div>
                <div>{label || children}</div>
                {subtitle && (
                    <div className={"select-list-item-subtitle"}>
                        {subtitle}
                    </div>
                )}
            </div>
        </div>
    );
}

SelectListItem.propTypes = {};

SelectListItem.defaultProps = {
    checkbox: false,
    checkboxIcon: "mui-check",
    checkboxUncheckedIcon: "mui-dot",
};

export default SelectListItem;
